import React from 'react'

import { cn } from '../../utils/common'

// Scale multiplier for numeric spacing values (8px grid)
const SCALE_UNIT = 8

interface TextProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode
  className?: string
  sx?: React.CSSProperties
}

// Convert the provided sx object into a React-compatible style object (camelCase keys preserved).
const sxToStyle = (
  sx?: React.CSSProperties
): React.CSSProperties | undefined => {
  if (!sx) return undefined
  return Object.entries(sx).reduce<React.CSSProperties>((acc, [key, value]) => {
    // Only scale primitive numeric values (skip objects like nested selectors which shouldn't appear here)
    const scaledValue = typeof value === 'number' ? value * SCALE_UNIT : value
    return { ...acc, [key]: scaledValue }
  }, {} as React.CSSProperties)
}

export const TitleText: React.FC<TextProps> = ({
  children,
  className,
  sx,
  ...props
}) => {
  const style = sxToStyle(sx)
  return (
    <h1
      className={cn(
        'text-2xl font-semibold p-0 m-0 text-[#181D27] break-words',
        className
      )}
      style={style}
      {...props}
    >
      {children}
    </h1>
  )
}

export const SubtitleText: React.FC<TextProps> = ({
  children,
  className,
  sx,
  ...props
}) => {
  const style = sxToStyle(sx)
  return (
    <p
      className={cn('text-base font-normal p-0 m-0 text-[#535862]', className)}
      style={style}
      {...props}
    >
      {children}
    </p>
  )
}

export const Label: React.FC<TextProps> = ({
  children,
  className,
  sx,
  ...props
}) => {
  const style = sxToStyle(sx)
  return (
    <label
      className={cn(
        'block text-sm font-medium leading-5 text-[#414651] mt-0 mb-1.5',
        className
      )}
      style={style}
      {...props}
    >
      {children}
    </label>
  )
}
